// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion {
  padding: 0;
}
.accordion div:last-child .accordion-item-details {
  border-radius: 5px;
}
.accordion-item-title {
  position: relative;
}
.accordion-item-trigger {
  width: 100%;
  text-align: left;
  background-color: transparent;
  border: none;
}
.accordion-item-details {
  overflow: hidden;
}
.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.accordion-item-enter-from,
.accordion-item-leave-to {
  height: 0 !important;
}
.accordion {
  padding: 0;
}
.accordion div:last-child .accordion-item-details {
  border-radius: 0.125rem;
}
.accordion-item-title {
  position: relative;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
